import React, { Component } from 'react'
import "./OrderKomp.css"

export default class OrderKomp extends Component {
    constructor(props) {
        super(props);
        this.state = {
          ORDERS: []
        };
      }
      componentDidMount() {
        this.setState({
          ORDERS: this.props.ORDERS
        });
      }
      render() {
    
        const Orders = this.state.ORDERS;
        let OrderTable = [];


        if (Orders.length) {
          let OrData = [];
    
          let Ubyl = [];
          let Prikaz = [];
          
          OrderTable.push(
              <table>
                <tbody className="tbody_Orders">
                  <tr className="header_table">
                    <th colSpan="6">Прибыл</th>
                    {Ubyl}
                  </tr>
                  <tr className="shapka_table">
                    <td>Курс</td>
                    <td>Уч. год</td>
                    <td>Приказ</td>
                    <td>Семестр</td>
                    <td>Специальность</td>
                    <td>Группа</td>
                    {Prikaz}
                  </tr>
                  {OrData}
                </tbody>
              </table>
          );
          for (let i = 0; i < Orders.length; i++) {
            OrData.push(
              <tr className="OrData">
                <td>{Orders[i].id_rate}</td>
                <td>{Orders[i].years}</td>
                <td>{Orders[i].pribil}</td>
                <td>{Orders[i].semester}</td>
                <td>{Orders[i].spec}</td>
                <td>{Orders[i].groups}</td>
                <td className="Ub_td">{Orders[i].ubil}</td>
              </tr>
            );
    
            if (i == 0) {
              Ubyl.push(<th className="Ubyl">Убыл</th>);
    
              Prikaz.push(<td className="Prikaz">Приказ</td>);
            }
    
          }
    
        } else {
        }
        ////////////////////////////////////////////////////////////////////////////////
        return (
                <div className="Orders_table">{OrderTable}</div>
        );
      }
}
 